import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon } from "../../icons/index.js";
const getDefaultAlignment = (langDir) => {
  return langDir === "rtl" ? "RIGHT" : "LEFT";
};
const alignmentMap = {
  LEFT: AlignLeftIcon,
  CENTER: AlignCenterIcon,
  RIGHT: AlignRightIcon
};
export {
  alignmentMap,
  getDefaultAlignment
};
//# sourceMappingURL=utils.js.map
